// In components/SEO.js

import React from 'react';
import { Helmet } from 'react-helmet-async'; // Use react-helmet-async for async support

const SEO = ({ title, description, canonical, ogImage, children }) => { // Make sure to accept 'children' here
  const siteTitle = "Jimatly";
  const defaultDescription = "Your default site description here"; // Update this
  const siteUrl = "https://www.jimatly.com"; // Update this
  const defaultImage = "https://www.jimatly.com/default-og-image.jpg"; // Update this

  return (
    <> {/* Use a Fragment to return multiple elements */}
      <Helmet>
        <title>{title ? `${title} | ${siteTitle}` : siteTitle}</title>
        <meta name="description" content={description || defaultDescription} />
        <link rel="canonical" href={canonical || siteUrl} />

        {/* Open Graph / Facebook */}
        <meta property="og:type" content="website" />
        <meta property="og:url" content={canonical || siteUrl} />
        <meta property="og:title" content={title || siteTitle} />
        <meta property="og:description" content={description || defaultDescription} />
        <meta property="og:image" content={ogImage || defaultImage} />

        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:url" content={canonical || siteUrl} />
        <meta name="twitter:title" content={title || siteTitle} />
        <meta name="twitter:description" content={description || defaultDescription} />
        <meta name="twitter:image" content={ogImage || defaultImage} />

        {/* Add other head elements if needed */}
      </Helmet>

      {/* THIS IS THE FIX: Render the content passed inside the <SEO> tags */}
      {children}
    </>
  );
};

export default SEO;